import React from "react";

export default function LightningIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <title>Lightning Icon</title>
            <path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z" />
        </svg>
    );
}
